import { __rest, __assign } from 'tslib';
import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

var DuplicateIcon = function (_a) {
    var _b = _a.ariaLabel, ariaLabel = _b === void 0 ? "Duplicate Icon" : _b, props = __rest(_a, ["ariaLabel"]);
    return (React.createElement(SvgIcon, __assign({}, props, { ariaLabel: ariaLabel }),
        React.createElement("path", { d: "M12.368 4H6.053C5.473 4 5 4.474 5 5.053v7.368h1.053V5.053h6.315V4zm-.526 2.105L15 9.263v5.263c0 .58-.474 1.053-1.053 1.053H8.153a1.051 1.051 0 01-1.048-1.053l.006-7.368c0-.58.468-1.053 1.047-1.053h3.684zm-.526 3.684h2.894l-2.894-2.894v2.894z" })));
};

export { DuplicateIcon };
//# sourceMappingURL=DuplicateIcon.esm.js.map
